import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class ScreenDesktopFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'rectangle';
    this.parentButton = WBUtils.buttonAdvanced;
  }

  /**
     * Creates and returns a fabric path object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    let desktopPath = 'M385.477,294.777V22.675H0v272.102h170.064v45.35h-45.35v22.675h136.051v-22.675h-45.35v-45.35H385.477z ';
    desktopPath += 'M22.675,249.427 V45.35h340.127v204.076H22.675z';

    this.shapeObject = new fabric.Path(desktopPath);
    this.shapeObject.set({
      left: anchorX,
      top: anchorY,
      fill: 'rgba(0,0,0,0)',
      stroke: color,
      strokeWidth: stroke / 2
    });

    this.shapeObject.scaleToWidth(5);

    return this.shapeObject;
  }

  /**
     * modifies the path object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({
        left: Math.abs(eventX)
      });
    }
    if (anchorY > eventY) {
      this.shapeObject.set({
        top: Math.abs(eventY)
      });
    }

    this.shapeObject.scaleToWidth(Math.abs(anchorX - eventX));
    this.shapeObject.setCoords();
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }

}
